import * as React from 'react';
import { AppBar as BaseAppBar, Toolbar, Typography } from '@material-ui/core';
import { CustomSignOut } from './parts/CustomSignOut';
// import SearchIcon from '@material-ui/icons/Search';

interface OwnProps {
  /** Homeボタンを表示するか */
  showHome?: boolean;
  /** homeボタンクリックハンドラー */
  onHomeClicked?: () => any;
}

export const AppBar: React.SFC<OwnProps> = (props: OwnProps) => {
  return (<div>
    <BaseAppBar position="static" color="primary">
      <Toolbar style={{
        alignItems: 'center',
        justifyContent: 'space-between'
      }}>
        <Typography variant="h6" color="inherit">
          AI診断システム
        </Typography>
        <CustomSignOut/>
      </Toolbar>
    </BaseAppBar>
  </div>);
}



// WEBPACK FOOTER //
// ./src/components/AppBar.tsx